(function (angular) {
	'use strict';

	var homePriceChartObject = {
		template: '<div class="aspect-ratio-2-1"><div id="home-price-chart" class="coterminous"></div></div>',
		controller: [
			'globalConfig',
			'Highcharts',
			'HIGHCHARTS_OPTIONS',
			HomePriceChartFunction
		],
		controllerAs: 'homePriceChart'
	};

	angular
		.module('viewMarketModule')
		.component('homePriceChart', homePriceChartObject);

	function HomePriceChartFunction(
		globalConfig,
		Highcharts,
		HIGHCHARTS_OPTIONS) {
		
		var homePriceChart = this;
		var chart;

		homePriceChart.$onChanges = function(changesObj){
			initChart();
		};

		Highcharts.setOptions(HIGHCHARTS_OPTIONS());

		function initChart(){
			chart = new Highcharts.Chart({
				chart: {
					type: 'line',
					renderTo: 'home-price-chart'
				},
				series: globalConfig.homePriceData,
				tooltip: {
					enabled: true,
					valuePrefix: '$',
					xDateFormat: "%B %Y"
				},
				xAxis: {
					type: 'datetime'
				},
				yAxis: {
					labels: {
						formatter: function() {
							return '$' + Highcharts.numberFormat(this.value / 1000, 0) + 'K';
						}
					}
				}
			});
		}
	}
})(window.angular);